import styled from 'styled-components';
import { themeGet, space } from 'styled-system';
import { Button } from 'src/kit';

export const StyledStepsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${themeGet('colors.paleGreyTwo')};
  ${space};
`;

export const StepButton = styled(Button)`
  position: relative;
  padding-bottom: 30px;
  display: block;
  flex: 1 1 auto;
  height: 100%;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.bold')};
  line-height: 1;
  text-align: center;
  z-index: 10;
  color: ${themeGet('colors.darkGreyBlue')};

  &.disabled {
    pointer-events: none;
    color: ${themeGet('colors.coolGrey')};
  }

  &.completed {
    color: ${themeGet('colors.textSecondary')};
  }

  &.active {
    color: ${themeGet('colors.primary')};
    &:after {
      content: '';
      position: absolute;
      bottom: -1px;
      display: block;
      width: 100%;
      height: 4px;
      background-color: ${themeGet('colors.primary')};
      white-space: nowrap;
    }
  }

  &:hover,
  &:focus {
    color: ${themeGet('colors.primary')};
  }
`;
